import React, { useEffect, useState } from "react";
import "./Services.css";
import AboutCard from "../Card/AboutCard";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";

function Services() {
  const [ServiceList, setServiceList] = useState([]);
  const [serviceInformation, setServiceInformation] = useState([]);
  const { backendUrl, translate } = useAppContext();
  const route = "/Service";
  const serviceListRoute = "/ServiceList";

  useEffect(() => {
    const fetchabout = async () => {
      try {
        const response = await axios.get(`${backendUrl}${route}`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setServiceInformation(response.data);
        }

        const aboutresponse = await axios.get(`${backendUrl}${serviceListRoute}`);
        if (Array.isArray(aboutresponse.data)) {
          setServiceList(aboutresponse.data);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchabout();
  }, [backendUrl]);

  return (
    <div>
      {Array.isArray(serviceInformation) && serviceInformation.length > 0 && (
        <div className="services-container animated">
          <div className="services-color-background">
            {serviceInformation.map((serviceInformations, index) => (
              <div key={index} className="text-container">
                <div className="service-title-container">
                  {serviceInformations.title && (
                    <div>
                      <h1>
                        {parse(translate(serviceInformations.title))}
                      </h1>
                    </div>
                  )}
                  <div className="title-underlined"></div>
                </div>
                <div className="w-100 d-flex justify-content-center">
                  {serviceInformations.content && (
                    <p style={{ fontWeight: "400" }}>
                      {parse(translate(serviceInformations.content))}
                    </p>
                  )}
                </div>
              </div>
            ))}
            <div>
              <AboutCard
                CardItem={ServiceList}
                apiEndPoint={backendUrl}
                apiRoute={serviceListRoute}
                image="photo"
                title="Services"
              ></AboutCard>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Services;
